<template>
  <b-card class="h-100" body-class="margin-top-fixed-header px-0">
    <fixed-header title="Add Part" />

    <part-form :partId="partId" @cancel="onClose" @partCreated="onPartCreated" />
  </b-card>
</template>

<script>
import { mapActions } from 'vuex';

import FixedHeader from '@/shared/components/FixedHeader/index';

import PartForm from '../PartForm';

export default {
  components: {
    FixedHeader,
    PartForm,
  },
  data() {
    return {
      partId: 0,
      part: {},
    }
  },
  methods: {
    onClose() {
      this.$router.go(-1);
    },
    onPartCreated(e) {
      this.part = {...e}
      this.$router.push({ name: 'parts'});
    },
  }
}
</script>